<template>
  <section class="wrapper">
    <div class="container">
      <div class="form_wrapper">
        <h3>Напишите мне, что бы мы смогли все обговорить)</h3>

        <div class="social_wrapper">
          <a href="https://t.me/whowashere" class="link tg" target="_blank">
            <i class="fab fa-telegram"></i>
          </a>
          <a href="https://vk.com/kirkland197" class="link vk" target="_blank">
            <i class="fab fa-vk"></i>
          </a>
          <a href="mailto:iulugbek21@gmail.com" class="link mail" target="_blank">
            <i class="fas fa-at"></i>
          </a>
          <!-- mailto:iulugbek21@gmail.com?subject=%D0%9F%D1%80%D0%B8%D0%B2%D0%B5%D1%82%2C%20%D0%B2%D0%BE%D1%82%20%D0%BC%D0%BE%D0%B5%20%D0%A2%D0%97&body=%D0%A1%D1%8E%D0%B4%D0%B0%20%D1%84%D0%B0%D0%B9%D0%BB -->
        </div>
      </div>
    </div>
  </section>
  
</template>

<script>
export default {
  name: "links",
  // data: () => {

  // }
};
</script>

<style>
.form_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.form_wrapper h3 {
  font-size: 28px;
  font-weight: 500;
  max-width: 480px;
  padding: 0 20px;
  margin-bottom: 110px;
  text-align: center;
}
.social_wrapper{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.link {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 50px;
  height: 50px;
  background-color: #fff;
  transform: translate(0, 0) rotate(-45deg) perspective(1000px) skew(15deg);
  transition: all 0.3s ease-in-out;
  margin: 0 25px;
}
.link::after,
.link::before {
  content: "";
  position: absolute;
  display: flex;
  transition: all 0.35s ease-out;
}
.link::after {
  width: 100%;
  height: 10px;
  transform: skew(-45deg);
  bottom: -10px;
  right: 5px;
  background-color: #e3e3e3;
}
.link::before {
  width: 10px;
  height: 100%;
  transform: skewY(-45deg);
  top: 5px;
  left: -10px;
  background-color: #c4c4c4;
}
.link:hover {
  transform: translate(0, -30px) rotate(-45deg) perspective(1000px) skew(15deg);
  color: #fff;
}


.link.vk:hover{
  background-color: #4c75a3;
}
.link.vk:hover::before{
  background-color: #345172;
}
.link.link.vk:hover::after{
  background-color: #40648d;
}


.link.tg:hover{
  background-color: #179cde;
}
.link.tg:hover::before{
  background-color: #0b6997;
}
.link.tg:hover::after{
  background-color: #37bcfc;
}


.link.mail:hover{
  background-color: #cd201f;
}
.link.mail:hover::before{
  background-color: #860b0a;
}
.link.mail:hover::after{
  background-color: #e93635;
}




</style>


// WEBPACK FOOTER //
// src/footer.vue